import config from '../../common/config';
import AjaxHelper from '../../common/js/AjaxHelper';

class TokenAuthService {

    async checkDueInfo(input) {
        const url = `${config.remoteUrl}/api/TokenAuth/CheckDueInfo`;
        var rs = await AjaxHelper.post(url, input);
        return rs.result;
    }

    async authenticate(input) {
        const url = `${config.remoteUrl}/api/TokenAuth/Authenticate`;
        var rs = await AjaxHelper.post(url, input);
        return rs.result;
    }

    async sendTwoFactorAuthCode(input) {
        const url = `${config.remoteUrl}/api/TokenAuth/SendTwoFactorAuthCode`;
        var rs = await AjaxHelper.post(url, input);
        return rs;
    }

    async impersonatedAuthenticate(impersonationToken) {
        const url = `${config.remoteUrl}/api/TokenAuth/ImpersonatedAuthenticate?impersonationToken=${impersonationToken}`;
        var rs = await AjaxHelper.post(url);
        return rs.result;
    }

    async linkedAccountAuthenticate(switchAccountToken) {
        const url = `${config.remoteUrl}/api/TokenAuth/LinkedAccountAuthenticate?switchAccountToken=${switchAccountToken}`;
        var rs = await AjaxHelper.post(url);
        return rs.result;
    }

    async getExternalAuthenticationProviders() {
        const url = `${config.remoteUrl}/api/TokenAuth/GetExternalAuthenticationProviders`;
        var rs = await AjaxHelper.get(url);
        return rs.result;
    }

    async externalAuthenticate(input) {
        const url = `${config.remoteUrl}/api/TokenAuth/ExternalAuthenticate`;
        var rs = await AjaxHelper.post(url, input);
        return rs.result;
    }

    async testNotification(input) {
        const url = `${config.remoteUrl}/api/TokenAuth/TestNotification`;
        var rs = await AjaxHelper.get(url, input);
        return rs;
    }
}

export default new TokenAuthService();
